import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { DOVE_API_BASE_URL, paramsSerializer } from '../api/api';
import { createClient as createAxiosClient } from './axiosClient';

export type DoveClient = AxiosInstance;

let doveClient: DoveClient;

export async function getDoveClient(): Promise<DoveClient> {
  if (doveClient) {
    return doveClient;
  }

  const options: AxiosRequestConfig = {
    baseURL: DOVE_API_BASE_URL,
    paramsSerializer,
  };

  doveClient = createAxiosClient(options);

  return doveClient;
}
